import Http from './base-http'

class ResetPassword extends Http {
  getResetPasswordVerificationLink(publicCode) {
    return this.client.get(`/resetpassword?publicCode=${publicCode}`)
  }

  resetPasswordVerificationLink(data) {
    return this.client.post('/resetpassword', data)
  }
}

const resetPassword = new ResetPassword({
  modelUrlPrefix : 'site'
})

export default resetPassword
